import { UserType } from '@nemuru-eng/js-api-client';

import { useUserContext } from '@/contexts/UserContext/UserContext';

export const useUser = () => {
  const { userEntity, structure, currentChannel, agent, updateUserContext } = useUserContext();

  const isUserAdmin = userEntity?.isUserType(UserType.ADMIN) || userEntity?.isUserType(UserType.SUPER_ADMIN);
  const isUserAgent = userEntity?.isUserTypeAgent();
  const isUserMerchant = userEntity?.isUserType(UserType.MERCHANT);
  const isUserMerchantGroup = userEntity?.isUserType(UserType.MERCHANT_GROUP);
  const isUserChannel = userEntity?.isUserType(UserType.CHANNEL);

  const isUserAgentId = (agentId: string) => userEntity?.agent?.id === agentId;

  const revalidateStructure = async () => {
    if (userEntity) {
      const structure = await userEntity.revalidateStructure();
      if (structure) updateUserContext({ structure });
    }
  };

  return {
    userEntity,
    structure,
    currentChannel,
    agent,
    isUserAdmin,
    isUserAgent,
    isUserChannel,
    isUserMerchant,
    isUserMerchantGroup,
    isUserAgentId,
    revalidateStructure,
  };
};
